<template>
  <div class="zyc-page-table-content mt20" ref="fullScreen">
    <table class="zyc-table" cellpadding="0" cellspacing="0">
      <thead>
        <tr>
          <th v-if="isNumber" style="width:40px;">序号</th>
          <th v-for="i in rowList" :align="i.align" :style="{ width:i.width }">{{ i.name }}</th>
        </tr>
      </thead>
      <tbody>
        <div v-if="isLoading" class="el-loading-mask" style=""><div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div></div>
        <template v-if="!isLoading">
          <div v-if="data.length < 1" class="zyc-page-table-empty">
            <h1>没有找到和查询条件相符的数据，原因可能是:<span>搜索的数据超出数据库查询范围</span></h1>
          </div>
        </template>
        <tr v-for="(i,index) in data" @click="rowClick(i)">
          <td v-if="isNumber" style="width:40px;">{{ serialMumber[index] }}</td>
          <template v-for="c in rowList">
            <td :style="{ width:c.width, 'text-align':c.align }">
              <div v-if="c.prop === 'action'" >
                <el-button type="primary" size="mini" style="margin: 5px 0;padding: 4px 8px;font-size: 16px;" @click.stop="downloadPDF(i.companyCode)">查看报告</el-button>
              </div>
              <div v-else :style="{ width:c.width, 'text-align':c.align }"><zyc-tooltipText :title="i[c.prop]"></zyc-tooltipText></div>

            </td>
          </template>
        </tr>
      </tbody>
    </table>

    <el-pagination v-if="total" @size-change="pageSizeChange"
                   @current-change="pageIndexChange"
                   :current-page="pageIndex"
                   :page-sizes="[10, 30, 50]"
                   :page-size="pageSize"
                   layout="total, sizes,slot, prev, pager, next, jumper"
                   class="mt20"
                   :pager-count="5"
                   :total="total">

    </el-pagination>
    <el-dialog title="设置"
               :modal-append-to-body="false"
               :visible.sync="setUpDialog.isDialog"
               width="688px">
      <el-transfer class="zyc-checkbox-group"
                   filterable
                   style="width:100%;"
                   :titles="['可选字段', '已选字段']"
                   :props="{key: 'prop', label: 'name'}"
                   filter-placeholder="请输入字段名称"
                   v-model="rowTitle"
                   :data="row">
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <span @click="restore">恢复默认选项</span>
        <el-button @click="setUpDialog.isDialog = false">取消</el-button>
        <el-button type="primary" @click="setUpClick">设置</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导出"
               :modal-append-to-body="false"
               :visible.sync="exportDialog.isDialog"
               width="688px">
      <el-transfer class="zyc-checkbox-group"
                   filterable
                   style="width:100%;"
                   :titles="['可选字段', '已选字段']"
                   :props="{key: 'value', label: 'label'}"
                   filter-placeholder="请输入字段名称"
                   v-model="rowExportTitle"
                   :data="rowField">
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <span @click="restoreExport">恢复默认选项</span>
        <el-button @click="exportDialog.isDialog = false">取消</el-button>
        <el-button type="primary" @click="exportClick">导出</el-button>
      </span>
    </el-dialog>
    <el-dialog title="企业创新能力评估报告"
               :modal-append-to-body="false"
               v-if="baogaoisDialog"
               :visible.sync="baogaoisDialog"
               width="688px" class="baogao">
      <div v-loading="baogaosrcLoading" v-if="baogaosrcLoading" style="width: 100%;height: 800px"
           element-loading-background="rgba(0, 0, 0, 0.1)"
           empty-text="加载中..."></div>
      <iframe v-show="!baogaosrcLoading" :src="baogaosrc" style="width: 100%;height: 800px"></iframe>
    </el-dialog>
  </div>
</template>
<script>
  /**
  * 排行Table
  */
  export default {
    name: 'zycPageTable',
    props: {
      data: {
        type: Array,
        default: []
      },
      option: {
        type: Object,
        default: () => {}
      },
      pageIndex: {
        type: Number,
        default: 1
      },
      pageSize: {
        type: Number,
        default: 10
      },
      total: {
        type: Number,
        default: 0
      },
      rowClick: {
        type: Function,
        default: () => { }
      },
      sizeChange: {
        type: Function,
        default: () => { }
      },
      pageChange: {
        type: Function,
        default: () => { }
      },
      isNumber: {
        type: Boolean,
        default: false
      },
      export: {
        type: Function,
        default: () => { }
      },
      rowField: {
        type: Array,
        default: () => []
      }
    },
    model: {
    },
    watch: {
      data: {
        handler: function (newVal, oldVal) {
          this.serialMumberPage(this.pageIndex)
          this.$forceUpdate()
        },
        immediate: true
      },
      rowField: {
        handler: function (newVal, oldVal) {
          if (newVal) {
            newVal.forEach(i => {
              this.option.columns.forEach(f => {
                if (f.name == i.label) {
                  this.rowExportTitle.push(i.value)
                  this.defaultExportTitle.push(i.value)
                }
              })
            })
          }
        },
        immediate: true
      },
      pageSize(val) {
        if (val) {
          this.value = val
        }
      }
    },
    data() {
      return {
        setUpDialog: {
          isDialog: false
        },
        exportDialog: {
          isDialog: false
        },
        baogaoisDialog:false,
        baogaosrcLoading:false,
        baogaosrc:'',
        isLoading: false,
        rowTitle: [],
        rowExportTitle: [],
        defaultExportTitle: [],
        rowTitles: [],
        rowList: [],
        row: [],
        serialMumber: [],
        options: [{
          value: 10,
          label: '10条/页'
        }, {
          value: 30,
          label: '30条/页'
        }, {
          value: 50,
          label: '50条/页'
        }],
        value: 10,
        isFullScreen: false
      }
    },
    mounted() {
      console.log('11111111',this.rowExportTitle)
    },
    created() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onresize)
        this.serialMumberPage(1)
        this.rowList = this.option.columns
        this.initSetUp()
      })
    },
    methods: {
      initSetUp: function () {
        this.rowTitle = []
        this.row = this.option.columns
        this.option.columns.forEach(i => {
          this.rowTitle.push(i.prop)
        })
      },
      onresize(event) {
        if (document.webkitIsFullScreen) {
          this.isFullScreen = true
        } else {
          this.isFullScreen = false
        }
      },
      showSetUp: function () {
        this.setUpDialog.isDialog = true
        this.rowTitles = this.rowTitle
      },
      showExport: function () {
        if (this.total > 10000) {
          this.$message.warning("批量导出数据量过大，已超过10000条，请筛选查询之后再导出。")
          return
        }
        this.exportDialog.isDialog = true
        this.rowTitles = this.rowTitle
      },
      showLoad: function () {
        this.isLoading = true
      },
      hideLoad: function () {
        this.isLoading = false
      },
      filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1;
      },
      restore: function () {
        this.initSetUp()
      },
      downloadPDF: function (id) {
        console.log(1111111,id)
        this.baogaosrc = '/exportPDF/PER?nobtn=1&id=' + id
        this.baogaoisDialog = true
        this.baogaosrcLoading = true
        setTimeout(()=>{
          this.baogaosrcLoading = false
        },2000)
        // this.$router.push({
        //   path: '/exportPDF/PER?id=' + id
        // })
      },
      restoreExport: function () {
        this.rowExportTitle = this.defaultExportTitle
      },
      setUpClick: function () {
        var arr = []
        this.option.columns.forEach(i => {
          if (this.rowTitle.indexOf(i.prop) > -1) {
            arr.push(i)
          }
        })
        this.rowList = arr
        this.rowTitles = this.rowTitle
        this.setUpDialog.isDialog = false
      },
      exportClick: function () {
        if (this.rowExportTitle.length < 1) {
          this.$message.warning("请选择需要导出的字段。")
          return
        }
        this.export(this.rowExportTitle)
        this.exportDialog.isDialog = false
      },
      dialogClose: function () {
        this.rowTitle = this.rowTitles
      },
      pageSizeChange: function (val) {
        this.sizeChange(val)
        this.serialMumberPage(1, val)
      },
      pageIndexChange: function (val) {
        this.serialMumberPage(val)
        this.pageChange(val)
      },
      serialMumberPage: function (page, size) {
        this.serialMumber = []
        if (!size) {
          size = this.pageSize
        }
        for (var i = page * size - size + 1; i <= page * size; i++) {
          this.serialMumber.push(i)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  /deep/ .el-pagination {
    .more + .number {
      display: none;
    }
  }
  /deep/ .baogao .el-dialog .el-dialog__body{
    max-height: 800px!important;
    padding-bottom: 20px;
  }

  /deep/ .el-dialog .el-transfer__buttons{
    padding: 0 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/zyc/table/pageTable.vue